// extracted by mini-css-extract-plugin
module.exports = {"pagelink":"pagelink_pagelink__3exX1","labelWrap":"pagelink_labelWrap__1cnAl","back":"pagelink_back__3_uu2","buttonWrap":"pagelink_buttonWrap__2UeHJ"};